// components/FileViewer.jsx
import React from 'react';
import { useFileLoader } from '../../hooks/useFileLoader';
import './FileViewer.css';

function FileViewer({ filePath, fileName, className, fileType: parentFileType, ...props }) {
    const { fileUrl, loading, error, fileType } = useFileLoader(filePath);

    // Загрузка
    if (loading) {
        return (
            <div className="file-loading">
                <div className="spinner"></div>
                
            </div>
        );
    }

    // Ошибка
    if (error || !fileUrl) {
        return (
            <div className="file-viewer error">
                <span>📁 {fileName || 'Файл'}</span>
                <span className="file-error">Не удалось загрузить</span>
            </div>
        );
    }

    // Определяем тип и рендерим
    const getFileIcon = () => {
        if (!fileType) return '📄';
        
        if (fileType.startsWith('image/')) return '🖼️';
        if (fileType.startsWith('video/')) return '🎬';
        if (fileType.startsWith('audio/')) return '🎵';
        if (fileType.includes('pdf')) return '📕';
        if (fileType.includes('word') || fileType.includes('document')) return '📘';
        if (fileType.includes('excel') || fileType.includes('spreadsheet')) return '📊';
        if (fileType.includes('zip') || fileType.includes('rar')) return '📦';
        return '📄';
    };

    // Изображения
    if (fileType?.startsWith('image/')) {
        return (
            <img 
                src={fileUrl} 
                alt={fileName || 'image'} 
                className={`file-viewer image ${className || ''}`}
                {...props}
            />
        );
    }

    // Видео
    if (fileType?.startsWith('video/') || filePath?.match(/\.(mp4|webm|ogg|avi|mov|mkv)$/i)) {
        return (
            <video 
                src={fileUrl} 
                controls 
                className={`${className || ''}`}
                {...props}
            />
        );
    }

    // Аудио
    if (fileType?.startsWith('audio/')) {
        return (
            <audio 
                src={fileUrl} 
                controls 
                className={`file-viewer audio ${className || ''}`}
                {...props}
            />
        );
    }

    // PDF
    if (fileType?.includes('pdf')) {
        return (
            <iframe 
                src={fileUrl} 
                className={`file-viewer pdf ${className || ''}`}
                title={fileName || 'PDF'}
                {...props}
            />
        );
    }

    // Другие файлы - ссылка на скачивание
    return (
        <a 
            href={fileUrl} 
            download={fileName || 'file'} 
            className={`file-viewer download-link ${className || ''}`}
            {...props}
        >
            <span className="file-icon">{getFileIcon()}</span>
            <span className="file-name">{fileName || 'Скачать файл'}</span>
        </a>
    );
}

export default FileViewer;